import * as React from 'react'
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group'
import { Circle } from 'lucide-react'
import { cn } from '@/lib/utils'

export const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => (
  <RadioGroupPrimitive.Root ref={ref} className={cn('flex flex-wrap gap-2', className)} {...props} />
))
RadioGroup.displayName = 'RadioGroup'

export const RadioGroupItem = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item> & { label: string }
>(({ className, label, ...props }, ref) => (
  <label
    className={cn(
      'flex-1 min-w-[100px] flex items-center gap-2 rounded-md border border-input bg-card px-3.5 py-2.5 text-sm font-medium cursor-pointer transition-colors hover:border-cosmos-green/50',
      'has-[[data-state=checked]]:border-cosmos-green has-[[data-state=checked]]:bg-cosmos-green/8',
      className
    )}
  >
    <RadioGroupPrimitive.Item
      ref={ref}
      className="aspect-square h-4 w-4 rounded-full border border-input text-cosmos-green focus:outline-none data-[state=checked]:border-cosmos-green"
      {...props}
    >
      <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
        <Circle className="h-2.5 w-2.5 fill-cosmos-green text-cosmos-green" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
    <span>{label}</span>
  </label>
))
RadioGroupItem.displayName = 'RadioGroupItem'
